<template>
  <div class="session-timeout-wrapper" v-if="showWarning">
    <div class="backdrop"></div>
    <div class="warning-modal">
      <strong>Inaktivitet</strong>
      <p>Din session håller på att gå ut på grund av inaktivitet.</p>
      
      <div class="timer-display">
        <div class="countdown">{{ formattedTime }}</div>
      </div>

      <div class="actions">
        <button class="btn" :disabled="extending" @click="extendSession">
          {{ extending ? 'Förlänger...' : 'Förläng session' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/classes/API';

export default {
  data() {
    return {
      secondsRemaining: 3600, // Fallback to 60 minutes
      timerInterval: null,
      extending: false,
      warningThreshold: 900, // 15 minutes in seconds
    };
  },
  computed: {
    showWarning() {
      return this.secondsRemaining > 0 && this.secondsRemaining <= this.warningThreshold;
    },
    formattedTime() {
      const minutes = Math.floor(this.secondsRemaining / 60);
      const seconds = this.secondsRemaining % 60;
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
  },
  methods: {
    resetTimer() {
      const maxLifetime = window.SITE_CONFIG && window.SITE_CONFIG.admin_session_lifetime
        ? parseInt(window.SITE_CONFIG.admin_session_lifetime, 10)
        : 3600;
      this.secondsRemaining = maxLifetime;
    },
    async extendSession() {
      this.extending = true;
      try {
        // Calling /admin/user updates last_activity_at on the backend
        await API.get('/admin/user');
        this.resetTimer();
      } catch (e) {
        // Safe fallback
      } finally {
        this.extending = false;
      }
    },
    tick() {
      this.secondsRemaining -= 1;
      if (this.secondsRemaining <= 0) {
        this.logoutExpired();
      }
    },
    async logoutExpired() {
      clearInterval(this.timerInterval);
      try {
        await API.get('/admin/logout');
      } catch (e) {
        // Ignore logout errors when session is already expired
      }
      this.$store.state.user = {};
      this.$router.push('/logga-in?admin=1&error=session_expired');
    },
  },
  mounted() {
    this.resetTimer();
    document.body.addEventListener('admin_api_activity', this.resetTimer);
    this.timerInterval = setInterval(this.tick, 1000);
  },
  beforeDestroy() {
    document.body.removeEventListener('admin_api_activity', this.resetTimer);
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  },
};
</script>

<style scoped>
.session-timeout-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(2px);
}

.warning-modal {
  position: relative;
  background: #ffffff;
  padding: 32px;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  text-align: center;
  animation: modalScale 0.3s ease-out;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

@keyframes modalScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.warning-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  background: #fffbeb;
  border-radius: 50%;
  color: #d97706;
  margin-bottom: 20px;
}

h2 {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 8px 0;
}

p {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

.timer-display {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
}

.timer-display span {
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.countdown {
  font-size: 32px;
  font-weight: 800;
  margin-top: 4px;
}

.btn-extend:disabled {
  cursor: not-allowed;
  transform: none;
}
</style>



// WEBPACK FOOTER //
// SessionTimeoutWarning.vue?2e80eb4a